<template>
    <div>
        <multiselect
            :placeholder="$t('select')"
            v-model="selected"
            :options="options"
            :class="validateError != '' ? 'box-border-color' : ''"
            @input="handleInput($event)"
            label="text"
            track-by="value"
            :multiple="false"
            :select-label="''"
            :selected-label="''"
            :deselect-label="''"
            :searchable="true"
            :internal-search="false"
            @search-change="searchHandler"
        >
            <span slot="noOptions">
                {{ $t("no_options") }}
            </span>
            <span slot="noResult">
                {{ $t("no_result") }}
            </span>
        </multiselect>

        <span class="invalid-feedback-custom"
              v-show="validateError"
              v-html="validateError"
        />
    </div>
</template>

<script>
// Helpers
import translateNSelected from "@/helpers/translateNSelected";
import handleInput from "@/helpers/handleInput";
import setSelected from "@/helpers/setSelected";

// Services
import ThesisAndProjectService from "@/services/ThesisAndProjectService";

// Other
import qs from "qs";

export default {
    props: {
        type: {
            type: String,
            default: 'thesis',
        },
        value: {
            default: null,
        },
        validateError: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            selected: null,
            options: [],
            allOptions: []
        }
    },

    watch: {
        value: {
            handler(newValue) {
                this.selected = setSelected(newValue, this.options);
            }
        },
        type: {
            handler(newValue) {
                this.clearOptions();
                if (newValue) {
                    this.getOptions();
                }
            }
        }
    },

    created() {
        this.getOptions();
    },

    methods: {
        handleInput,
        setSelected,
        translateNSelected,

        normalizeText(text) {
            return text
                .toString()
                .toLowerCase()
                .replace(/ı/g, 'i')
                .replace(/İ/g, 'i')
                .replace(/ö/g, 'o')
                .replace(/Ö/g, 'o')
                .replace(/ü/g, 'u')
                .replace(/Ü/g, 'u')
                .replace(/ş/g, 's')
                .replace(/Ş/g, 's')
                .replace(/ğ/g, 'g')
                .replace(/Ğ/g, 'g')
                .replace(/ç/g, 'c')
                .replace(/Ç/g, 'c');
        },

        searchHandler(query) {
            if (!query) {
                this.options = this.allOptions;
                return;
            }

            const normalizedQuery = this.normalizeText(query);

            this.options = this.allOptions.filter(item =>
                this.normalizeText(item.text).includes(normalizedQuery)
            );
        },

        getOptions() {
            const config = {
                params: {
                    type: this.type,
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            };

            ThesisAndProjectService.getAdvisors(config)
                .then((response) => {
                    const data = response.data.data;

                    this.allOptions = data.map((item) => ({
                        value: item.user_id,
                        text: item.name + " " + item.surname,
                    }));

                    this.options = this.allOptions;
                })
                .then(() => {
                    this.selected = setSelected(this.value, this.options);
                });
        },

        clearOptions() {
            this.selected = null;
            this.options = [];
            this.allOptions = [];
        }
    }
}
</script>
